export default "__VITE_ASSET__8etzEzMy__"